import { render, staticRenderFns } from "./quick_item.vue?vue&type=template&id=34b0f508&scoped=true&"
import script from "./quick_item.vue?vue&type=script&lang=js&"
export * from "./quick_item.vue?vue&type=script&lang=js&"
import style0 from "./quick_item.vue?vue&type=style&index=0&id=34b0f508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0f508",
  null
  
)

export default component.exports